import React, { useEffect, useRef } from 'react'

const GalleryPopup = ({mediaArray, setToggleFullscreen}) => {

    useEffect(()=>{
  
      // Handle event
      function handleEsc(e){ 
        e.stopPropagation();
        if(e.key === 'Escape' || e.target.localName !=='img') {
          e.preventDefault();
          setToggleFullscreen(false)  
        }
      }
      // Set event 
      document.addEventListener('keydown', handleEsc );
      document.addEventListener('click', handleEsc );
  
      // Remove event on component removed
      return function(){
        document.removeEventListener('keydown', handleEsc )
        document.removeEventListener('click', handleEsc )
      }
    });

    const popup_el = useRef(null);

    return (
      <div ref={popup_el} className="gallery-popup" >
          <a href="#visa-fullskarm" title="Stäng fullskärm" onClick={ (e)=>{ e.preventDefault(); setToggleFullscreen(false) } }>&times;</a>
  
          <ul>
          {mediaArray.map( ( image, i ) => {
            return (
                <li key={i + 'popup'}>
                    <img className="loading" onLoad={e=>{ e.target.classList.toggle('loading')}} src={image} alt='' />
                </li>
            )
          } )}
          </ul>
  
      </div>
    )
  
  }

  export default GalleryPopup;